module.exports = __webpack_public_path__ + "assets/img/checked3-37ced0bc.png";